import { isUndefinedOrNull } from 'util/checks'

import { OrientacaoFormModel, OrientacaoRowModel } from './types/OrientacoesModel'

export function convertRowModelToFormModel(row: OrientacaoRowModel): OrientacaoFormModel {
  if (isUndefinedOrNull(row)) {
    return row
  }

  return {
    editingId: row?.editingId,
    descricao: row?.descricao,
  }
}
